<template>
  <div class="autocomplete-popup__input-container-group q-input-group q-mb-1 q-input-group-lg">
    <ClosePopupButton v-if="showAutocompletePopup"/>
    <SearchInput :autocomplete="true"/>
  </div>
</template>

<script setup lang="ts">
import SearchInput from "@/components/SearchInput.vue";
import ClosePopupButton from './ClosePopupButton.vue'

import {usePopupStore} from "@/store/AutocompletePopup/PopupStore";
import {storeToRefs} from "pinia";

const popupStore = usePopupStore()
const {showAutocompletePopup} = storeToRefs(popupStore)
</script>


<style scoped>
@media (max-width: 768px) {
  .q-autocomplete-active .autocomplete-popup__input-container-group .autocomplete-popup__input-container {
    width: 90%;
  }

  .q-autocomplete-active .autocomplete-popup__input-container-group .autocomplete-popup__close-button-container {
    width: 10%;
  }
}


</style>
